// Punto único de configuración — importar desde acá en lugar de repetir en cada archivo
export const API_URL =
  process.env.REACT_APP_ENVIRONMENT === 'local'
    ? 'http://localhost:3000'
    : process.env.REACT_APP_API_URL;
